import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: calc(100% - 60px);
  padding: 40px 30px;
  background: #fff;
`;

export const Title = styled.p`
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: GmarketSansMedium, sans-serif;
  font-size: 22px;
`;

export const SelectTabWrapper = styled.div`
  margin-top: 20px;
  width: calc(100% - 2px);
  height: 47px;
  border: 1px solid #78818e;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SelectedTab = styled.div`
  cursor: pointer;
  flex: 1;
  height: 100%;
  background: #fff;
  color: #373f4c;

  display: flex;
  align-items: center;
  justify-content: center;

  ${(props) =>
    props.isSelected &&
    css`
      background: #78818e;
      color: #fff;
      font-weight: bold;
    `};
`;

export const Table = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border: 1px solid rgb(227, 227, 227);
  margin-top: 20px;

  background: #fff;
  & > thead th {
    height: 46px;
    background: #fafafa;
    border-bottom: 1px solid #e3e3e3;
  }

  & > tbody > tr > td {
    height: 67px;
    text-align: center;
  }

  & > tbody > tr > td:first-child > div {
    display: flex;
    justify-content: center;
    width: 100%;
    flex-direction: column;
  }

  & > tbody tr:not(:last-child) {
    border-bottom: 1px solid #e3e3e3;
  }

  & > tbody > tr > td:nth-child(2) {
    text-align: right;
  }
  & > tbody > tr > td:nth-child(3) {
    font-weight: normal;
    font-family: Tahoma, -apple-system, SF Pro Display, Helvetica Neue, sans-serif;
    font-size: 18px;
  }
  & > tbody > tr > td:nth-child(4) {
    text-align: left;
  }

  & > tbody > tr > td:nth-child(5) {
    padding: 0 15px;
  }
`;

export const TeamContainer = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
    ${(props) => 
      props.alignStart  ? 
      css`
        justify-content: flex-end;
      ` : css`
       justify-content: flex-start
      `}
`

export const TeamName = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100px;
  margin: 0 7px;
  vertical-align: middle;
  ${(props) =>
    props.isSelected &&
    css`
      font-weight: bold;
    `};
`;

export const TeamLogo = styled.div`
  margin: 0 5px;
  display: inline-block;
  vertical-align: middle;

  & > img {
    height: 25px;
  }
`;
